import { render, staticRenderFns } from "./card_cirurgia.vue?vue&type=template&id=4aba19a6&"
import script from "./card_cirurgia.vue?vue&type=script&lang=js&"
export * from "./card_cirurgia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports